/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import contractIcon from "../../assets/icons/progress/icon_progressbar_vertrag.svg";
import documentsIcon from "../../assets/icons/progress/icon_progressbar_vertrag_upload.svg";
import insuranceIcon from "../../assets/icons/progress/icon_progressbar_versicherung.svg";

const progressBarSteps = [
  {
    key: "contract",
    name: "Ihr Mietvertrag",
    icon: contractIcon,
  },
  {
    key: "documents",
    name: "Unterlagen",
    icon: documentsIcon,
  },
  {
    key: "insurance",
    name: "Versicherung",
    icon: insuranceIcon,
  },
];

export default progressBarSteps;
